import React, { useState, useEffect } from 'react';
import {
  Container,
  Grid,
  Typography,
  Modal,
  Backdrop,
  Fade,
} from '@material-ui/core';
import CardEgrnCoin from '../shared/cardEgrnCoin/cardEgrnCoin';
import CardUsd from '../shared/cardUsd/cardUsd';
import Orders from '../shared/orders/orders';
import Footer from '../footer/Footer';
import { useStyles, ExchangeLogic, WalletService } from './exchange.module';
import GraphicExchangePage from '../GraphicExchangePage/GraphicExchangePage';
import Transactions from '../transactions/transactions';

const Exchange = (props) => {
  const classes = useStyles();
  const service = WalletService();
  const { values } = ExchangeLogic(props, service.getData);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleModalOpen = () => {
    setOpenModal(true);
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };

  return (
    <div className={classes.dashboardStyle}>
      <Container>
        {/* <Grid container spacing={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <User user={values.user} />
          </Grid>
        </Grid> */}
      </Container>

      <Container>
        <Grid container spacing={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <div className={classes.subtitleDashboard}>
              <Typography className={classes.textSubtitleDashboard}>
                Exchange
              </Typography>
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item lg={1} md={1} sm={1} xs={12}></Grid>
          <Grid item lg={10} md={10} sm={10} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <CardEgrnCoin
                  value={values.totalCoins}
                  available={values.availableCoins}
                />
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <CardUsd
                  tooltip={'buy usd'}
                  title={'Current USD'}
                  value={values.totalUSD}
                  available={values.availableUSD}
                  onClick={handleModalOpen}
                />
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Orders userId={values.id} />
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Transactions />
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={1} md={1} sm={1} xs={12}></Grid>
        </Grid>

        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className={classes.coinSoon}
        ></Grid>
      </Container>
      <Footer />
      <Modal
        className={classes.modal}
        open={openModal}
        onClose={handleModalClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
      >
        <Fade in={openModal}>
          <div className={classes.modalContent}>
            <GraphicExchangePage />
          </div>
        </Fade>
      </Modal>
    </div>
  );
};
export default Exchange;
